// In production the backend serves both the API and the built frontend from
// the same origin (see backend/index.js), so relative fetches ("") just work —
// whether that's localhost:8000 in Docker or the real deployed domain.
// In dev (npm start) there's no backend on this origin, so point at the
// locally running backend directly.
export const HOST = process.env.NODE_ENV === "production" ? "" : "http://localhost:3001";
